/**
 * Identifica lote de endosso a partir do payload do GET de lote ou da lista de pendentes.
 */
export function isBatchEndorsementPayload(data) {
  if (!data || typeof data !== 'object') return false;
  if (data.is_endorsement === true) return true;
  const raw = data.batch_envelope_type ?? data.batch_type ?? '';
  const t = String(raw).toLowerCase();
  return t.includes('endorse') || t.includes('endosso');
}
